import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { useLegacyAccess } from '@/pages/legacy/shared';
import { ParticipantProfile } from './ParticipantProfilePage';
import { PROFILE_MEDCALL_REFERENCE } from './queries';

export const MedcallParticipantProfile = ({ medcall }: { medcall: string }) => {
  const access = useLegacyAccess();
  const allowed = access('tools:medcall:access:~user');
  const valid = /^[1-9]\d{0,9}$/.test(medcall) && Number(medcall) <= 4294967295;
  const result = useQuery<{ participantProfileForMedcallNumber: { odrnumber: number | null } | null }>(PROFILE_MEDCALL_REFERENCE, {
    variables: { medcall }, skip: !valid || !allowed, fetchPolicy: 'network-only',
  });
  if (!valid) return <p role="alert">Enter a valid MedCall participant number.</p>;
  if (!allowed) return <p role="alert">MedCall access is unavailable.</p>;
  if (result.loading) return <p role="status">Opening MedCall profile…</p>;
  if (result.error) return <p role="alert">{result.error.message}</p>;
  const odrnumber = result.data?.participantProfileForMedcallNumber?.odrnumber;
  if (!odrnumber) return <p role="alert">The participant profile is unavailable.</p>;
  return <ParticipantProfile key={odrnumber} odrnumber={odrnumber} initialSection="Medcall" />;
};

export const MedcallParticipantProfileRoute = () => {
  const { participantId } = useParams();
  return <MedcallParticipantProfile key={participantId} medcall={participantId ?? ''} />;
};
